import { render, staticRenderFns } from "./CalendarioPromocional.vue?vue&type=template&id=c84521de"
import script from "./CalendarioPromocional.vue?vue&type=script&lang=js"
export * from "./CalendarioPromocional.vue?vue&type=script&lang=js"
import style0 from "./CalendarioPromocional.vue?vue&type=style&index=0&id=c84521de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports